import React, { memo } from 'react';
import styled from 'styled-components';
import Flag from 'react-flagkit';
import OrderStatus from '../OrderStatus';

import Name from '../../Clients/Name/Name';
import { IOrderSearchInfo } from '@components/CRM/Search/types';

interface IOrderSearchCard extends IOrderSearchInfo {
  className?: string;
  ticketable: boolean;
  onCallClick: ({ value }: { value: string }) => void;
  onClick: () => void;
  onCreateTicket: () => void;
  onEmailClick: () => void;
}

const OrderSearchCard = ({
  countryCode = '',
  region = '',
  details,
  onCreateTicket,
  status,
  orderId,
  href,
  clientId,
  name = '',
  ticketable = true,
  ...props
}: IOrderSearchCard) => (
  <StyledOrderSearchCard {...props}>
    <StyledClient>
      {clientId && (
        <StyledIdentifier title={String(clientId)}>{clientId}</StyledIdentifier>
      )}
      <StyledName name={name} />
    </StyledClient>
    <StyledOrder>
      <StyledCommon>
        <StyledOrderStatus href={href} id={orderId} status={status} />
        {countryCode && <StyledCountryFlag country={countryCode} />}
        {region && <StyledRegion title={region}>{region}</StyledRegion>}
        {details && <StyledDetails title={details}>{details}</StyledDetails>}
      </StyledCommon>
      {countryCode && <StyledCountryCode>{countryCode}</StyledCountryCode>}
    </StyledOrder>
  </StyledOrderSearchCard>
);

const StyledOrderSearchCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 44px;
  background-color: #fff;
`;

const StyledIdentifier = styled.div`
  padding-right: 9px;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: normal;
  color: #919499;

  ::before {
    content: '#';
  }
`;

const StyledName = styled(Name)`
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
`;

const StyledOrderStatus = styled(OrderStatus)`
  width: 190px;
  height: 17px;
  line-height: 18px;
  overflow: visible;
  text-align: left;
`;

const StyledOrder = styled.div`
  display: flex;
  width: 100%;
  height: 18px;
  color: #919499;
  line-height: 18px;
  margin-bottom: 5px;
`;

const StyledCountryFlag = styled(Flag)`
  height: 100%;
  margin-left: 11px;
  width: 17px;
`;

const StyledClient = styled.div`
  display: flex;
  width: 100%;
  height: 18px;
  font-size: 14px;
  margin-top: 5px;
`;

const StyledRegion = styled.div`
  color: #4d4d4d;
  height: 100%;
  padding-left: 11px;
  max-width: 200px;
  min-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledDetails = styled.div`
  color: #4d4d4d;
  height: 100%;
  padding-left: 11px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledCommon = styled.div`
  display: flex;
  flex-grow: 1;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
`;

const StyledCountryCode = styled.div`
  padding-left: 11px;
`;

export default memo(OrderSearchCard);
